export * from './HomePage'
export * from './Header'
export * from './DesktopMenu'
export * from './SolutionsSection'
export * from './SupportSection'
export * from './PartnersSection'
export * from './GoalSection'
export * from './Footer'


// WEBPACK FOOTER //
// ./src/components/index.js